// export DsfHomePendingProcess from './pendingProcess.vue'
export const DsfHomePendingProcess = dsf.defineAsyncComponent("DsfHomePendingProcess", () => {
  return dsf.requestAsyncComponents($components.platform.DsfVirtualList).then(() => {
    return import(/*webpackChunkName:"platform_pc_homepage"*/ "./pendingProcess.vue");
  });
});
